















































































































import { Component, Mixins } from "vue-property-decorator";
import GameMixin, { GameInterface } from "@/components/GameMixins.vue";
import ItemSelection, { item } from "@/components/shared/ItemSelection.vue";
import Undo from "@/components/shared/Undo.vue";
import Difficulty from "@/components/shared/Difficulty.vue";
import {
  edge,
  graph,
  alphabet,
  dijkstra,
  checkValidity,
  getShortestPath,
  getResultEdges,
} from "@/components/paths/Graph";


@Component<Weights>({
  components: {
    ItemSelection,
    Undo,
    Difficulty,
  },
})
export default class Weights extends Mixins(GameMixin) implements GameInterface {
  g: graph = {nVertices:0, nEdges:0, edges:[]};
  origin: number = null;
  sink: number = null;
  oVertex: string;
  sVertex: string;;
  currentDifficultyLevel = 1;
  nE = this.edgeNumber(this.currentDifficultyLevel);
  difficultyLevels = 3;
  resultEdges: number[] = null;
  solutionWord = "anzeigen";
  tries = 0;
  fastest = 0;
  showSol = false;


  edgeNumber(currentDifficultyLevel): number {
    switch (currentDifficultyLevel) {
      case 1: {
        return 12;
      }
      case 2: {
        return 20;
      }
      case 3: {
        return 28;
      }
      default: {
        return 12;
      }
    }
  }

  limit(currentDifficultyLevel): number {
    switch (currentDifficultyLevel) {
      case 1: {
        return 20;
      }
      case 2: {
        return 20;
      }
      case 3: {
        return 20;
      }
      default: {
        return 100;
      }
    }
  }

  matrix1 = [[0, 1], [0, 4], [1, 2], [1, 3], [2, 3], [2, 5], [3, 4], [3, 5], [3, 6], [4, 7], [5, 6], [6, 7]];
  matrix2 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 5], [2, 6], [3, 6], [3, 7], [4, 5], [4, 8], [5, 8], [5, 9], [6, 7], [6, 9], [7, 10], [8, 11], [9, 10], [9, 11], [10, 11]];
  matrix3 = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 4], [2, 3], [2, 5], [3, 6], [3, 7], [4, 5], [4, 8], [5, 6], [5, 8], [5, 9], [6, 7], [7, 9], [7, 10], [8, 11], [8, 12], [9, 12], [9, 13], [10, 13], [10, 14], [10, 15], [11, 13], [11, 14], [11, 15], [13, 14]];

  off() {
    document.getElementById("overlay0").style.display = "none";
    document.getElementById("overlay1").style.display = "none";
    document.getElementById("overlay2").style.display = "none";
    document.getElementById("overlay3").style.display = "none";
    document.getElementById("overlay4").style.display = "none";
    document.getElementById("overlay5").style.display = "none";
    document.getElementById("overlay6").style.display = "none";
    document.getElementById("overlay7").style.display = "none";
    document.getElementById("overlay8").style.display = "none";
    document.getElementById("overlay11").style.display = "none";
    document.getElementById("overlay12").style.display = "none";
    document.getElementById("overlay13").style.display = "none";
  }

  on(id: number) {
    document.getElementById(`overlay${id}`).style.display = "block";
    if (id == 13){
      setTimeout(() => {
        this.off();
      }, 5000);
    } else {
      setTimeout(() => {
          this.off();
      }, 3500);
    }
  }

  toggleColor(id: number){
      const index = id - 1;
      const list = document.getElementById(id.toString()).classList;
      //const list = document.getElementById(`r_${id}`).classList;
      if (list[4] == 'sel'){
        //document.getElementById(`r_${id}`).classList.remove('sel');
        document.getElementById(id.toString()).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "black"
        this.g.edges[index].selected=false;
      } else {
        //document.getElementById(`r_${id}`).classList.add('sel');
        document.getElementById(id.toString()).classList.add('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${id}`).style.color = "red"
        this.g.edges[index].selected=true;
      }
  }

  showSolution(){
    for(let i = 0; i < this.resultEdges.length; i ++){
      const index = this.resultEdges[i]
      // const list = document.getElementById(i.toString()).classList;
      const list = document.getElementById(`r_${index}`).classList;
      if (list[4] == 'sel'){
        document.getElementById(`r_${index}`).classList.remove('sel');
        this.solutionWord = "anzeigen"
      } else {
        document.getElementById(`r_${index}`).classList.add('sel');
        this.solutionWord = "verstecken"
      }
    }
  }

  changeDifficultyLevel(newLevel: number) {
    this.currentDifficultyLevel = newLevel;
    this.nE = this.edgeNumber(this.currentDifficultyLevel);
    this.start(); 
  }

  removeWeights(){
    document.getElementById(`blub`).remove();
  }

  removeSelection(){
    for (let i = 1; i <= this.nE; i++) {
      try {
        document.getElementById(i.toString()).classList.remove('sel');
        document.getElementById(`r_${i}`).classList.remove('sel');
        document.getElementById(`l_${this.currentDifficultyLevel}_${i}`).style.color = "black"
        this.g.edges[i-1].selected=false;
      } catch {
          console.log("not removed")
      }
    }
  }

  isInitialized(): boolean {
    return this.origin !== null;
  }

  start(){
    this.tries = 0;
    this.showSol = false;
    if(this.nE){
      this.removeSelection();
    }
    let matrix = null;
    switch (this.currentDifficultyLevel) {
      case 1: {
        this.g.nVertices=8;
        this.g.nEdges=12;
        this.g.edges;
        matrix = this.matrix1;
        break;
      }
      case 2: {
        this.g.nVertices=12;
        this.g.nEdges=20;
        this.g.edges;
        matrix = this.matrix2;
        break;
      }
      case 3: {
        this.g.nVertices=16;
        this.g.nEdges=28;
        this.g.edges;
        matrix = this.matrix3;
        break;
      }
      default: {
        matrix = this.matrix1;
        break;
      }
    }
    this.g.edges = [];
    for (let i = 1; i <= this.g.nEdges; i++) {
      const e: edge = {id:i, v1:matrix[i-1][0], v2:matrix[i-1][1], weight:Math.ceil(this.randomNumber(this.limit(this.currentDifficultyLevel))), selected:false};
      this.g.edges.push(e)
    }
    
    this.origin = Math.floor(this.randomNumber(this.g.nVertices));
    do{
      this.sink = Math.floor(this.randomNumber(this.g.nVertices));
    } while (this.origin == this.sink);

    this.removeSelection;
    this.oVertex = alphabet[this.origin];
    this.sVertex = alphabet[this.sink];
  
  }

  //returns the ID numbers of the selected edges
  getSelected(): number[]{
    const sel: number[] = [];
      for (let i = 0; i < this.g.nEdges; i++){
          const index = i + 1;
          const list = document.getElementById(index.toString()).classList;
          if (list[4] == 'sel'){
            sel.push(i);
          }
      }
    return sel
  }

  undo(){
    this.removeSelection();
    this.solutionWord = "anzeigen";

  }



  proposedSolution(): number {
    let sol = 0;
    for (let i = 0; i < this.g.nEdges; i++) {
      if(this.g.edges[i].selected){
        sol = sol + this.g.edges[i].weight;
      }
    }
    return sol;
  }

  
  isCorrect() {
    
    const x = checkValidity(this.g, this.getSelected(), this.origin, this.sink);
    let check = x == 9;
    
    if (!check) {
      this.on(x);
    } else {this.off();}
    
    const a = this.proposedSolution();
    
    this.fastest = dijkstra(this.g, this.origin, this.sink);
    const path = getShortestPath(this.g, this.origin, this.sink);
    if(!(a == this.fastest) && check){
      check = false;
      this.tries++;
      if (this.tries < 3){
        this.on((10 + this.tries));
      } else {
        this.on(13);
      }
    }
    
    if(this.tries >= 3){
      this.showSol = true;
    }
    this.resultEdges = getResultEdges(this.g, path);
    
    const sol: boolean[] =[];
    sol.push((a==this.fastest));
    sol.push((check));
    
    return sol;
  }
  
  
}


